import { ReactNode } from "react";
import { NextSortOrder, SortOrder, SortOrderValue } from "../constants";
import { noop } from "utils/helper/functions";
import Checkbox from "components/atoms/checkbox/Checkbox";
import { SortArrow } from "../SortArrow/SortArrow";
import Tooltip from "components/atoms/tooltip/tooltip";
import HelpIcon from "components/icons/HelpIcon";

export interface ColumnProps {
  name?: string;
  sortOrder?: SortOrderValue;
  sortable?: boolean;
  onSortChange?: (args: any) => void;
  isAllSelected?: boolean;
  isAllDisabled?: boolean;
  toggleAllSelected?: (args) => void;
  indeterminate?: boolean;
  tooltipText?: ReactNode;
}

export const Column = ({ name = '', sortOrder = SortOrder.NONE, sortable = false, onSortChange = noop, isAllSelected, toggleAllSelected, isAllDisabled, indeterminate, tooltipText }: ColumnProps) => {
  const sort = () => {
    const nextOrder = NextSortOrder[sortOrder];
    onSortChange(nextOrder);
  };

  return (
    <div
      className={`flex select-none items-center gap-1 ${sortable ? 'cursor-pointer' : ''}`}
      onClick={sortable ? sort : undefined}>
      {toggleAllSelected && (
        <Checkbox
          checked={isAllSelected}
          onChange={toggleAllSelected}
          indeterminate={indeterminate}
          disabled={isAllDisabled}
          size='checkbox-xs'
        />
      )}

      <p>{name}</p>

      {sortable && (
        <div className='grid'>
          <SortArrow
            arrow='up'
            active={sortOrder === SortOrder.ASC}
          />

          <SortArrow
            arrow='down'
            active={sortOrder === SortOrder.DESC}
          />
        </div>
      )}
      {tooltipText && (
        <Tooltip
          infoData={{
            tooltip: <HelpIcon svgClassname={'h-4 w-4'} />,
            content: tooltipText,
            position: 'tooltip-top',
          }}
        />
      )}
    </div>
  );
};
